import { FinancialQuestionnaireTypesEnum } from '../../enums';
import { ENROLL_METHOD } from '../../models/enroll';

export const INDIVIDUAL_EXTENDED_INFO_CALL_NAME = 'crm/individualExtendedInfo';


const {
  UNSP, XANI, XENW, ELNW, TEWS, ATPY, AVPY, TKLP, AVFM, POWL, AITI,
} = FinancialQuestionnaireTypesEnum;

export const INDIVIDUAL_EXTENDED_INFO_CALL_LIMIT = 10;
